import React from "react";

export const highlightText = (text, searchTerm) => {
  if (!searchTerm) return text;

  try {
    const escapedSearchTerm = searchTerm.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

    const regex = new RegExp(`(${escapedSearchTerm})`, "gi");

    return text?.split(regex).map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span
          key={index}
          style={{
            backgroundColor: "#3498db",
            color: "white",
            fontWeight: "bold",
            padding: ".1em",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  } catch (err) {
    console.error("Invalid search term for highlightText:", err);
    return text;
  }
};


export const Logos = {
  MINERVA_LOGO: "https://stminervaclouddev.blob.core.windows.net/images-store/minerva-logo.png",
  GENERICDOC_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/genericDoc.png",
  ADOBE_PDF_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/adobe-pdf-icon.webp",
  EMAIL_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/emailicon.png",
  EXCEL_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/excel.png",
  PDF_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/pdf.png",
  WORD_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/word.png",
  PPT_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/ppt.png",
  IMAGE_ICON: "https://stminervaclouddev.blob.core.windows.net/images-store/image.png"
}

export const getSubDomain = () => {
  let subdomain = new URL(window.location.href).hostname.split(".")[0];
  if (subdomain === "localhost") {
    subdomain = process.env.LOCAL_SUBDOMAIN;
  }
  return subdomain
}